import React, { Component } from 'react'
// import { Route, Link } from 'react-router-dom'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import DatePicker from '../../Shared/DatePicker'
import { YearSelect } from '../Charts/partials/YearSelect'
import { MonthSelect } from '../Charts/partials/MonthSelect'
import { WeekSelect } from '../Charts/partials/WeekSelect'
import { dashboardService } from '../../../_services/dashboard.service'
import { withStyles } from '@material-ui/core/styles'
import Fab from '@material-ui/core/Fab'
import { FiRefreshCw } from 'react-icons/fi'
import Tooltip from '@material-ui/core/Tooltip'
import { HdfChart } from '../Charts/charts/HdfChart'
import { ProductionChart } from '../Charts/charts/ProductionChart'
import { DoughnutChart } from '../Charts/charts/DoughnutChart'
// import { MainBarChart } from '../Charts/charts/MainBarChart'
import TotalRecordsBox from '../Charts/partials/TotalRecordsBox'

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    fontFamily: 'IranSans'
  }
}))(Tooltip)

class Tab1 extends Component {
  constructor(props, context) {
    super(props, context)
    // const brandId = JSON.parse(localStorage.getItem('user')).brand.brandId
    this.state = {
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      key: 'locations',
      activeTransporter: '',
      tickets: [],
      trpisLoading: false,

      yearsData: [],
      currentYear: undefined,
      brand: 0,
      year: undefined,
      month: 0,
      week: undefined,
      date: undefined,
      currentDate: undefined
    }
  }

  componentDidMount = () => {
    dashboardService.getDate().then(res => {
      console.log(res.data)
      this.setState(
        {
          year: res.data.currentYear,
          currentYear: res.data.currentYear,
          month: res.data.currentMonth,
          date: res.data.currentDate,
          currentDate: res.data.currentDate,
          yearsData: res.data.years
        },
        () => {
          this.getData()
        }
      )
    })
  }

  getData() {
    this.setState({ loading: true })

    const { brand, year, month, week, date } = this.state

    var dto = {}
    dto['brandId'] = brand ? brand : undefined
    dto['year'] = year
    dto['month'] = month ? month : undefined
    dto['week'] = week
    dto['date'] = date

    // console.log(JSON.stringify(dto))
    dashboardService
      .GetStatistics(JSON.stringify(dto))
      .then(res => {
        // console.log(res.data)
        this.setState({
          data: res.data,
          loading: false
        })
      })
      .catch(error => {
        this.setState({ loading: false })
      })
  }

  handleBrandSelect = val => {
    // console.log(val);

    this.setState({ brand: val }, () => {
      this.getData()
    })
  }

  handleYearSelect = val => {
    this.setState({ year: val }, () => {
      this.getData()
    })
  }

  handleMonthSelect = val => {
    const { week } = this.state
    let newWeek = week
    if (!val && week > 0) {
      newWeek = undefined
    } else if (val && week == 0) {
      newWeek = undefined
    }
    this.setState({ month: val, week: newWeek }, () => {
      this.getData()
    })
  }

  handleWeekSelect = val => {
    this.setState({ week: val }, () => {
      this.getData()
    })
  }

  handleDateChange = val => {
    this.setState({ date: val }, () => {
      this.getData()
    })
  }

  render() {
    const {
      yearsData,
      year,
      month,
      date,
      loading,
      data,
      currentDate
    } = this.state
    return (
      <div>
        <div className="row">
          <div className="col-lg-10 col-lg-offset-1">
            <div className="row">
              <div className="col-md-2">
                <AsyncBrandSelect
                  disabled={loading}
                  className="semantic-select-box"
                  placeholder="برند"
                  clearable
                  brandType={1}
                  onChange={val => {
                    this.handleBrandSelect(val)
                  }}
                />
              </div>
              <div className="col-md-2">
                <YearSelect
                  disabled={loading}
                  data={yearsData}
                  defaultValue={year}
                  onChange={val => this.handleYearSelect(val)}
                />
              </div>
              <div className="col-md-2">
                <MonthSelect
                  disabled={!year || loading}
                  clearable
                  defaultValue={month}
                  onChange={val => this.handleMonthSelect(val)}
                />
              </div>
              <div className="col-md-2">
                <WeekSelect
                  disabled={loading}
                  clearable
                  type={month ? 1 : 2}
                  onChange={val => this.handleWeekSelect(val)}
                />
              </div>
              <div className="col-md-2">
                <DatePicker
                  disabled={loading}
                  clearable
                  onChange={val => this.handleDateChange(val)}
                  defaultValue={date}
                  maxDate={currentDate}
                />
              </div>
              <div className="col-md-2">
                <LightTooltip title="بروزرسانی" arrow placement="top">
                  <Fab
                    disabled={loading}
                    color="secondary"
                    aria-label="refresh"
                    size="small"
                    onClick={() => this.getData()}
                    style={{ boxShadow: 'none' }}>
                    <FiRefreshCw
                      size="20px"
                      className={loading ? 'mdi-spin mdi-loading' : ''}
                    />
                  </Fab>
                </LightTooltip>
              </div>
            </div>
            <div className="row mt-30">
              <div className="col-md-2">
                <TotalRecordsBox
                  title="تعداد کل پارکت تولید شده"
                  value={data && data.totalProduct}
                  loading={loading}
                />
              </div>
              <div className="col-md-2">
                <TotalRecordsBox
                  title="تعداد کل پارکت درجه 2"
                  value={data && data.totalGradeTwoProduct}
                  loading={loading}
                />
              </div>
              <div className="col-md-2">
                <TotalRecordsBox
                  title="تعداد کل ضایعات تایل"
                  value={data && data.totalTileWaste}
                  loading={loading}
                />
              </div>
              <div className="col-md-2">
                <TotalRecordsBox
                  title="تعداد کل ورق پرس شده"
                  value={data && data.totalHdf}
                  loading={loading}
                />
              </div>
              <div className="col-md-2">
                <TotalRecordsBox
                  title="تعداد کل ضایعات ورق پرس شده"
                  value={data && data.totalHdfWaste}
                  loading={loading}
                />
              </div>
            </div>
            <div className="row mt-30">
              <div className="col-md-6" style={{ display: 'relative' }}>
                <DoughnutChart data={data} loading={loading} type={1} />
              </div>
              <div className="col-md-6" style={{ display: 'relative' }}>
                <DoughnutChart data={data} loading={loading} type={2} />
              </div>
            </div>
            <div className="row mt-30">
              <div className="col-md-12" style={{ display: 'relative' }}>
                <ProductionChart
                  data={data && data.productionChartData}
                  loading={loading}
                />
              </div>
            </div>
            <div className="row mt-30">
              <div className="col-md-12" style={{ display: 'relative' }}>
                <HdfChart
                  data={data && data.productionChartData}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Tab1
